import { useContext } from 'react';
import get from 'lodash/get';
import { DeviationResourceType } from '../../types/deviation';
import { getSellableAs } from '../../types/deviation/getters';
import { getDeviationResourceType, isSimpleDeviation, getCanHavePremiumDownload, isHyped, isMultiImageDeviation, isBoostedDeviation } from '../_helpers';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { isExtendedDeviationFullyLoaded } from '../../DeviationPage/redux/helpers';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
function getIsEditable(deviation) {
    const canUserEdit = get(deviation, 'extended.canUserEdit', false);
    // Hacky way to sometimes hide the edit button
    if (deviation.legacyTextEditUrl === '#' || deviation.extended && deviation.extended.editUrl === '#') {
        return false;
    }
    return canUserEdit;
}
export function useDeviationAttributes(deviation, isOwner) {
    var _deviation_extended, _deviation_extended1, _deviation_extended2, _deviation_author;
    const { isLoggedIn } = useContext(SessionContext);
    const booster_flag = useFlag('booster');
    const resourceType = getDeviationResourceType(deviation);
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const isMultiImage = isMultiImageDeviation(deviation);
    const isSimple = isSimpleDeviation(deviation);
    const isReportable = !isOwner && !isSimple;
    const isShareable = deviation.isShareable || isSimple;
    const isGroupSubmittable = !isSimple && (isExtendedLoaded ? !!((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.canUserAddToGroup) : isLoggedIn);
    const isDeletable = isExtendedLoaded ? !!((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.canUserDelete) : isOwner;
    const isBoostable = booster_flag && !!((_deviation_extended2 = deviation.extended) === null || _deviation_extended2 === void 0 ? void 0 : _deviation_extended2.isBoostable);
    const isBoosted = booster_flag && isBoostedDeviation(deviation);
    const hasMoreActions = isShareable || isReportable;
    const hasNft = false;
    return {
        hasFlag: !!deviation.dailyDeviation || !!isHyped(deviation),
        hasMoreActions,
        isCommentable: !!deviation.isCommentable,
        isFavouritable: !isSimple && !isOwner,
        isGroupSubmittable,
        isDownloadable: !!deviation.isDownloadable,
        isAdoptable: !!deviation.isAdoptable,
        isPurchasable: !!deviation.isPurchasable,
        isShareable,
        isReportable,
        isSellable: getSellableAs(deviation).length > 0,
        canHavePremiumDownload: getCanHavePremiumDownload(deviation),
        isEditable: getIsEditable(deviation),
        isDeletable,
        isBackgroundEditable: !!deviation.isBackgroundEditable,
        isAuthorCommissionable: ((_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.type) !== 'banned',
        isCoreBadgeAwardable: !isOwner && resourceType === DeviationResourceType.ART,
        isExtendedLoaded,
        hasNft,
        isBoostable,
        isBoosted,
        isMultiImage
    };
}

//# sourceMappingURL=useDeviationAttributes.js.map